export default __webpack_public_path__ + "static/media/arrow-left.c80ba3af.svg";